import { create } from 'zustand';

export const aiproUser = create((set) => ({
    user: '',
    setUser: (userHelper) => set(() => ({ user: userHelper }))
}));

export const subscriptionType = create((set) => ({
    type: '',
    setType: (typeHelper) => set(() => ({ type: typeHelper })),
    payment_interval: '',
    setPaymentInterval: (intervalHelper) => set(() => ({ payment_interval: intervalHelper }))
}));

export const usePopup = create((set) => ({
    showPricingPopup: false,
    setShowPricingPopup: (popupHelper) => set(() => ({ showPricingPopup: popupHelper })),
    showProcessLoading: false,
    setShowProcessLoading: (state) => set(()=> ({ showProcessLoading: state }))
}));

export const conversationList = create((set)=>({
    conversation: [],
    setConversation: (convo) => set(()=> ({ conversation: convo})),
    convoLoad: true,
    setConvoLoad: (status) => set(()=>({ convoLoad: status })),
    pageNumber: 1,
    setPageNumber: (page) => set(()=> ({ pageNumber: page })),
    totalPage: 1,
    setTotalPage: (page) => set(()=> ({ totalPage: page }))
}))

export const useConversation = create((set)=>({
    data: {},
    setData: (convo) => set(()=> ({ data: convo})),
    message: [],
    setMessage: (msg) => set(()=>({ message: msg })),
    isStreaming: false,
    setIsStreaming: (stream) => set(()=>({ isStreaming: stream })),
    view: 'chat',
    setView: (data) => set(()=>({ view: data }))
}))